export default function stripHTML(text) {
  if (text === null || undefined) return '';
  const parser = new DOMParser(),
    doc = parser.parseFromString(text, 'text/html');
  // textContent may be an empty string if text is not well-formed HTML
  return doc.body.textContent || text;
}
